import { ApolloError, OperationVariables, QueryHookOptions, gql } from '@apollo/client';
import { DocumentNode } from 'graphql';
import { useMemo } from 'react';
import { useGraphql } from 'utils/hooks/useGraphql';

import { MessageCategory } from '../types';

export type QueryMessageCategoriesVariables = OperationVariables;
export type QueryMessageCategoriesResponse = {
  messageCategories: MessageCategory[];
};

type QueryMessageCategoriesOptions = QueryHookOptions<
  QueryMessageCategoriesResponse,
  QueryMessageCategoriesVariables
>;

export type UseQueryMessageCategoriesResult = {
  errorMessage?: ApolloError;
  hasError: boolean;
  isLoading: boolean;
  refetch: (variables?: Partial<QueryMessageCategoriesVariables>) => void;
  messageCategories: MessageCategory[];
};

export const queryMessageCategories = gql`
  query getMessageCategories {
    messageCategories {
      id
      name
      projectId
      createdAt
      updatedAt
      createdBy
      updatedBy
      rowsCount
    }
  }
`;

export const useQueryMessageCategories = (
  options?: QueryMessageCategoriesOptions,
  query: DocumentNode = queryMessageCategories,
): UseQueryMessageCategoriesResult => {
  const queryOptions: QueryMessageCategoriesOptions = useMemo(
    () => ({
      notifyOnNetworkStatusChange: true,
      fetchPolicy: 'no-cache',
      ...options,
    }),
    [options],
  );

  const {
    data,
    errorMessage,
    isLoading,
    error: hasError = false,
    refetch,
  } = useGraphql<QueryMessageCategoriesResponse, QueryMessageCategoriesVariables>(
    query,
    queryOptions,
  );

  return {
    messageCategories: data?.messageCategories ?? [],
    errorMessage,
    hasError,
    isLoading,
    refetch,
  };
};
